import { Link } from "react-router-dom";
import ProductListCards from "../../../../components/ProductListCards/ProductListCards";
import Button, { ButtonType } from "../../../../components/Button/Button";
import Pencil from "../../../../assets/pencil";
import { OrderSplitAPIResponse } from "../../../../interfaces/interfaces";

interface Props {
  splitAPIResponse: OrderSplitAPIResponse;
  isOrderAvailableToCCPayment: boolean;
}

const CartInformation = ({ splitAPIResponse }: Props) => {
  return (
    <div className="cart-information">
      <div className="cart-header">
        <h3>Product List</h3>
        <Link replace to="/store/cart">
          <Button
            type={ButtonType.secondary}
            style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}
          >
            <Pencil width={13} height={13} />
            Edit Cart
          </Button>
        </Link>
      </div>
      <div className="order-list">
        <ProductListCards items={splitAPIResponse.current_order.order_items} bo />
      </div>
    </div>
  );
};

export default CartInformation;
